import { Container, Heading, Flex, Divider } from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import PassDownloadTemplateForm from '../../components/client/pass-download-template/PassDownloadTemplateForm';
import { PassDownloadTemplateContextProvider } from '../../store/client/PassDownloadTemplateContext';

const PassDownloadTemplateCreatePage = () => {
  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'pass download pages',
      linkUrl: '/pass-download-pages',
    },
    {
      linkName: 'create pass download page',
      linkUrl: null,
    },
  ];

  return (
    <PassDownloadTemplateContextProvider>
      <Container display="flex" flexDir="column" flex="1" pb={6}>
        <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
        <Flex
          flexDirection={{ base: 'column', sm: 'row' }}
          alignItems="center"
          flexWrap="wrap"
          mt="15px"
          py="9px"
          minH="54px"
        >
          <Heading>Create pass download page</Heading>
        </Flex>
        <Divider borderColor="primaryBackground" mb={6} />
        <PassDownloadTemplateForm />
      </Container>
    </PassDownloadTemplateContextProvider>
  );
};

export default PassDownloadTemplateCreatePage;
